import { render, staticRenderFns } from "./section6.vue?vue&type=template&id=701b1d6e&scoped=true"
import script from "./section6.vue?vue&type=script&lang=js"
export * from "./section6.vue?vue&type=script&lang=js"
import style0 from "./section6.vue?vue&type=style&index=0&id=701b1d6e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701b1d6e",
  null
  
)

export default component.exports